import { Auth } from '@or-sdk/auth';

import config from '../config';
import { authCookieDomain, authUiUrl, sdkApiUrl } from '../utils/authUiRuntime';

export default new Auth({
  cookieDomain: authCookieDomain,
  cookiePrefix: config.COOKIE_NAME_PREFIX_NEW,
  allowGuestLogin: Boolean(config.GUEST_LOGIN),
  userCookieName: `${config.COOKIE_NAME_PREFIX}_name`,
  multiUserCookieName: `${config.COOKIE_NAME_PREFIX}_multi`,
  userExpireCookieName: `${config.COOKIE_NAME_PREFIX}_user_expire`,
  expireInShort: +`${config.COOKIE_EXPIRATION_SHORT}`,
  expireInLong: +`${config.COOKIE_EXPIRATION_LONG}`,
  sdkUrl: sdkApiUrl,
  authUiUrl,
  allowIframe: Boolean(config.ALLOW_IFRAME),
});
